import { createApp } from "vue";
import DashboardOverview from "./pages/DashboardOverview.vue";
import MemberListAll from "./pages/MemberListAll.vue";
import SuccessorListAll from "./pages/SuccessorListAll.vue";
import ApplicationList from "./pages/ApplicationList.vue";
import SongListAll from "./pages/SongListAll.vue";
import SongView from "./pages/SongView.vue";
import SongAdd from "./pages/SongAdd.vue";
import ApplicationDetail from "./pages/ApplicationDetail.vue";
import MemberProfile from "./pages/MemberProfile.vue";
import MemberAdd from "./pages/MemberAdd.vue";
import SuccessorAdd from "./pages/SuccessorAdd.vue";
import AdminUsers from "./pages/AdminUsers.vue";
import AdminRoles from "./pages/AdminRoles.vue";
import AdminSettings from "./pages/AdminSettings.vue";
import AdminSettingsSmtp from "./pages/AdminSettingsSmtp.vue";
import AdminSettingsApproveMail from "./pages/AdminSettingsApproveMail.vue";
import ChangePassword from "./pages/ChangePassword.vue";
import PublicApplication from "./pages/PublicApplication.vue";

/**
 * หน้า PHP ที่พร้อมย้ายมา Vue จะใส่ data-mct-vue="<ชื่อ>" แล้วลงทะเบียนที่นี่
 * หน้าอื่นยังใช้สคริปต์ใน PHP เดิม — โหลด Vue ทั้ง shell แล้วแต่ยังไม่ mount
 */
const pages = {
  "dashboard-overview": DashboardOverview,
  "member-list-all": MemberListAll,
  "successor-list-all": SuccessorListAll,
  "application-list": ApplicationList,
  "song-list-all": SongListAll,
  "song-view": SongView,
  "song-add": SongAdd,
  "application-detail": ApplicationDetail,
  "member-profile": MemberProfile,
  "member-add": MemberAdd,
  "successor-add": SuccessorAdd,
  "admin-users": AdminUsers,
  "admin-roles": AdminRoles,
  "admin-settings": AdminSettings,
  "admin-settings-smtp": AdminSettingsSmtp,
  "admin-settings-approve-mail": AdminSettingsApproveMail,
  "change-password": ChangePassword,
  "public-application": PublicApplication,
};

function readConfig(el) {
  var script = el.querySelector("script[type='application/json']");
  var raw = "{}";
  if (script && typeof script.textContent === "string" && script.textContent.trim()) {
    raw = script.textContent;
  } else {
    raw = el.getAttribute("data-mct-vue-config") || "{}";
  }
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (err) {
    return {};
  }
}

function mountAll() {
  const nodes = document.querySelectorAll("[data-mct-vue]");
  for (let i = 0; i < nodes.length; i++) {
    const el = nodes[i];
    if (el.__mctVueMounted) {
      continue;
    }
    const name = el.getAttribute("data-mct-vue") || "";
    const Page = pages[name];
    if (!Page) {
      continue;
    }
    el.__mctVueMounted = true;
    createApp(Page, { config: readConfig(el) }).mount(el);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountAll);
} else {
  mountAll();
}
